export const useMainImage = (images) => {
  const mainImage = images?.find((image) => image?.isMain === true);
  const image = {
    url: mainImage?.url,
    label: mainImage?.label,
  };
  return image;
};
